import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import FormRow from "../../components/Row/FormRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";

export default class VehicleMakeAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      name: "",
      loading: false,
    };
    this.pathname = "vehicles";
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const edit = this.props.location.data;
    if (edit) {
      this.setState({
        ...edit,
      });
    }
  }

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const { id, ...data } = this.state;
    let response;

    if (id) {
      response = await this.engine.updateItem(this.pathname, id, data);
    } else {
      response = await this.engine.saveItem(this.pathname, data);
    }

    if (response && (response.status === 201 || response.status === 200)) {
      this.props.history.push("/admin/" + this.pathname);
    }

    this.setState({ loading: false });
  };

  changeInput = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    this.setState({ [name]: trimmedValue });
  };

  render() {
    const { loading, isLoading, name } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={this.handleValidSubmit}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  <FormRow
                    label={strings.name}
                    name="name"
                    data={name}
                    changeInput={this.changeInput}
                  />
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
